import _get from 'lodash/get'
import React from 'react'
import { useController } from 'react-hook-form'

import { useStepContentText } from '@flows-ui/utils/useStepContentText'
import type { SelectionButtonSet as SelectionButtonSetProps } from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'
import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/SvgIcon'
import UiKitSelectionButtonSet from '@ui-kit/components/formComponents/SelectionButtonSet'
import type { Option } from '@ui-kit/components/formComponents/SelectionButtonSet/types'

export const SelectionButtonSet = <TProps extends SelectionButtonSetProps<any, any>>(
  props: TProps & { flowValues: FlowValues }
) => {
  const { field, fieldState } = useController({ name: props.name })
  const translateFunction = useStepContentText(props.flowValues)

  const formattedOptions = props.options.map(
    (option): Option => ({
      value: option.value,
      title: translateFunction(option.title),
      subtitle: option.subtitle ? translateFunction(option.subtitle) : undefined,
      icon: option.iconPath ? <Icon imgSrc={_get(IMAGE, option.iconPath)} /> : undefined,
    })
  )

  return (
    <UiKitSelectionButtonSet
      options={formattedOptions}
      selectType={props.selectType}
      variant={props.variant}
      noOutline={props.noOutline}
      value={field.value ?? ''}
      disabled={props.disabled}
      errorMessage={fieldState.error?.message}
      onValueChange={field.onChange}
    />
  )
}
